import Vue from 'vue'

import App from './App.vue'

import router from './router'

import store from './store'

import vuetify from './plugins/vuetify'

import axios from "axios";

import Vuelidate from 'vuelidate'

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

Vue.use(Vuelidate)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
